import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import React from 'react';

interface RadioGroupFieldProps extends React.ComponentProps<typeof RadioGroup> {
  children: React.ReactNode;
}

export const RadioField = ({ children, ...props }: RadioGroupFieldProps) => {
  return <RadioGroup {...props}>{children}</RadioGroup>;
};

export const RadioFieldOption = ({
  label,
  value,
  disabled
}: {
  label: string;
  value: string;
  disabled?: boolean;
}) => {
  return (
    <FormControlLabel
      value={value}
      sx={{
        marginBottom: '0px',
        '& .MuiFormControlLabel-label': {
          fontSize: '14px',
          fontWeight: '400',
          lineHeight: '21px'
        }
      }}
      control={
        <Radio
          sx={{
            '& .MuiSvgIcon-root': {
              fontSize: '16px'
            }
          }}
        />
      }
      label={label}
      disabled={disabled}
    />
  );
};
